import { render } from "./YieldRiskWarningPanel.vue?vue&type=template&id=25e67e79&scoped=true"
const script = {}

import "./YieldRiskWarningPanel.vue?vue&type=style&index=0&id=25e67e79&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e67e79"]])

export default __exports__